import SmsActionTypes from './types';

export const fetchSmsConfiguration = () => ({
  type: SmsActionTypes.FETCH_SMS_CONFIGURATION,
});

export const fetchSmsConfigurationSuccess = (payload) => ({
  type: SmsActionTypes.FETCH_SMS_CONFIGURATION_SUCCESS,
  payload,
});

export const fetchSmsConfigurationFailure = (payload) => ({
  type: SmsActionTypes.FETCH_SMS_CONFIGURATION_FAILURE,
  payload,
});

export const updateSmsConfiguration = (data, cb) => ({
  type: SmsActionTypes.UPDATE_SMS_CONFIGURATION,
  payload: { data, cb },
});

export const updateSmsConfigurationSuccess = (payload) => ({
  type: SmsActionTypes.UPDATE_SMS_CONFIGURATION_SUCCESS,
  payload,
});

export const updateSmsConfigurationFailure = (payload) => ({
  type: SmsActionTypes.UPDATE_SMS_CONFIGURATION_FAILURE,
  payload,
});

export const fetchSmsLogs = (params = {}) => ({
  type: SmsActionTypes.FETCH_SMS_LOGS,
  payload: params,
});

export const fetchSmsLogsSuccess = (payload) => ({
  type: SmsActionTypes.FETCH_SMS_LOGS_SUCCESS,
  payload,
});

export const fetchSmsLogsFailure = (payload) => ({
  type: SmsActionTypes.FETCH_SMS_LOGS_FAILURE,
  payload,
});
